import { createBasicLoopbackRepository } from 'elentari'
import { paginate } from '../../lib/loopback'

import { restApi } from '../../services/Api'

const MensagemUsuarioRepository = usuario =>
  createBasicLoopbackRepository({
    path: `usuarios//${usuario?.id}/mensagem-usuarios`,
    queryTransform: {
      ...paginate
    },
    restApi
  })

export default MensagemUsuarioRepository
